import { useState, useCallback } from 'react';
import type { CodeBlock } from '../types';
import { HighlightedCode, type HljsLanguage } from '../HighlightedCode';
import { IconCopy, IconCheck } from './icons';

export function CodeBlockView({ block }: { block: CodeBlock }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(block.code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [block.code]);

  return (
    <div className="code-block applied" data-testid="code-block">
      <div className="code-block-header">
        <span className="code-filename" data-testid="code-filename">{block.filename || block.language}</span>
        <div className="code-block-actions">
          <button
            className="code-action-btn"
            onClick={handleCopy}
            title="Copy code"
            data-testid="code-copy-btn"
          >
            {copied ? <IconCheck /> : <IconCopy />}
          </button>
        </div>
      </div>
      <HighlightedCode
        code={block.code}
        filename={block.filename}
        language={block.language as HljsLanguage | undefined}
        className="code-block-content"
      />
    </div>
  );
}
